module.exports = __webpack_public_path__ + "img/cacao-footer-OPCION-1.2506d029.png";